import { Dialog, DialogContent, Grid } from '@mui/material'
import { PDFViewer } from '@react-pdf/renderer'
import PdfCheckIn from '../../../utils/pdfComponets/pdfCheckIn'

const ModalImprime = ({ data, close }) => {
  const handleClose = (status) => () => {
    close(status)
  }

  return (
    <Dialog maxWidth="lg" fullWidth open={true} onClose={handleClose(null)}>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PDFViewer width="100%" height="600px">
              <PdfCheckIn {...data} />
            </PDFViewer>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalImprime
